import React from 'react';

const GuideMeContext = React.createContext({
  themes: [],
  topics: [],
  mediaTypes: [],
  currentStep: 0,
  filter: '',

  themeOptions: [],
  mediaTypeOptions: [],
  config: {},

  onSelect: () => {},

  dialogContentRef: null,
});

export default GuideMeContext;
